import { render } from "./uz.vue?vue&type=template&id=e20ab744&scoped=true&ts=true"
import script from "./uz.vue?vue&type=script&lang=ts"
export * from "./uz.vue?vue&type=script&lang=ts"

import "./uz.vue?vue&type=style&index=0&id=e20ab744&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20ab744"]])

export default __exports__